module.exports = __webpack_public_path__ + "img/url_embed.2b81daa3.svg";